import React from 'react'
import { connectSortBy } from 'react-instantsearch-dom'

import Typography from 'components/UI/Typography/Typography'

import styles from './CustomSortBy.module.css'

type SortByProps = {
  items: { value: string; label: string; isRefined: boolean }[]
  refine: (value: string) => void
}

const SortBy = ({ items, refine }: SortByProps): JSX.Element => (
  <div className={styles.wrapper}>
    {items.map(({ value, label, isRefined }) => (
      <label key={value} htmlFor={value} className={styles.group}>
        <Typography.BodySmall className={styles.label}>
          {label}
        </Typography.BodySmall>
        <input
          type="radio"
          id={value}
          value={value}
          checked={isRefined}
          className={styles.radio}
          onChange={() => refine(value)}
        />
      </label>
    ))}
  </div>
)

const CustomSortBy = connectSortBy(SortBy)

export default CustomSortBy
